var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tool-intro-/-icon_pills"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "pill",
    transform: "translate(2.000000, 2.000000)",
    stroke: "currentColor",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53553391,14.3955006 L14.3955006,3.53553391 C16.348122,1.58291245 19.5139469,1.58291245 21.4665684,3.53553391 L22.4644661,4.53343161 C24.4170876,6.48605307 24.4170876,9.65187796 22.4644661,11.6044994 L11.6044994,22.4644661 C9.65187796,24.4170876 6.48605307,24.4170876 4.53343161,22.4644661 L3.53553391,21.4665684 C1.58291245,19.5139469 1.58291245,16.348122 3.53553391,14.3955006 Z M9.28847508,9.19625318 L17.0026248,16.368667",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3592263,4.74039481 C18.5103533,4.74039481 19.8419151,6.07195655 19.8519545,8.86189712",
    id: "Path",
    strokeLinecap: "round",
    transform: "translate(17.605590, 6.801146) rotate(-45.000000) translate(-17.605590, -6.801146) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPills);
export default __webpack_public_path__ + "static/media/icon_pills.8a64dbe20a20be840f12921d3c3cb634.svg";
export { ForwardRef as ReactComponent };